import styled from "styled-components";

export const PreLineParagraph = styled.p`
  white-space: pre-line;
`;
